import { Theme } from '../shared/theme.model';
import { Interest } from '../skills/interest.model';
import { Skill } from '../skills/skill.model';
import { CommunityWithRoles } from './community-with-roles.model';
import { GeographicalArea } from './geographical-area.model';
import { OrganizationAsUserProperty } from './organization-as-user-property.model';
import { PwaStatus } from './pwa-status.enum.model';
import { UserPermissions } from './user-permission.model';
import { UserStatusTypes } from './user-status-types.model';
import { UserType } from './user-type.model';

export class ResponseFromAccountActivationFollowUp {
    public errors: string;
    public success: string;
}

export class ResponseFromBatchInsertUser {
    public errors: { [key: string]: string } = {};
    public rapport: string;
    public success: { [key: string]: string } = {};
}

export class User {
    public active: boolean;
    public city: string;
    public country: string;
    public communities: CommunityWithRoles[];
    public description: string;
    public email: string;
    public hideEmail: boolean;
    public emailConfirmed: boolean;
    public firstName: string;
    public geographicalArea: GeographicalArea;
    public geographicalAreaId: string;
    public interests: Interest[];
    public isExternal: boolean;
    public isOnBoardingProfileCompleted: boolean;
    public jobTitle: string;
    public lastName: string;
    public linkedIn: string;
    public mobilePhone: string;
    public officePhone: string;
    public organization: OrganizationAsUserProperty;
    public password: string;
    public permissions: UserPermissions;
    public pictureReference: string;
    public primaryCommunity: CommunityWithRoles;
    public profilePicture: string;
    public skills: Skill[];
    public status: UserStatusTypes;
    public termsOfUse: boolean;
    public theme: Theme;
    public userId: string;
    public userType: UserType;
    public isProductTourCompleted: boolean | null;

    public pwaStatus: PwaStatus;
    public hasViewedCommunityInformation: boolean;

    constructor(object?: Partial<User>) {
        Object.assign(this, object);
    }

    public static sortByFullName = (a: User, b: User) => `${a.firstName} ${a.lastName}`.localeCompare(`${b.firstName} ${b.lastName}`);
}

export enum ModifierTypes {
    Owner = 'Owner',
    CommunityManager = 'CommunityManager',
    OrganizationLeader = 'OrganizationLeader',
    None = 'None',
}

export const USER_SKILLS_MAX = 10;
export const USER_INTERESTS_MAX = 10;
